import { navigate } from 'gatsby';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useLocation } from '~/context/LocationContext';
import trackCustomEvent from '~/utilities/trackCustomEvent';

import Button from '~/components/base/Button';
import Modal from '~/components/base/Modal';
import Icon from '~/components/base/Icon';

import ComparisonTable from '~/components/ComparisonTable';
import AddWashModal from '~/components/modal/AddWashModal';

import { useUser } from '~/context/UserContext';

import { formatText } from '~/utilities/helpers';

const StyledButton = styled(Button)`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const ButtonGroupButton = ({
    url = '',
    title,
    icon = null,
    useComparisonTable = false,
    comparisonTableProductCategory = null,
    addWashButton = false
}) => {
    const { isLoggedIn } = useUser();
    const location = useLocation();
    const [open, setOpen] = useState(location.state?.addWash || false);
    const doButtonAction = () => {
        if (useComparisonTable) {
            setOpen(true);
            trackCustomEvent('pricing_table_view', {});
        } else if (addWashButton) {
            if (isLoggedIn) {
                setOpen(true);
            } else {
                navigate('/account/login', {
                    state: { from: location.pathname, addWash: true }
                });
            }
        }
    };

    return (
        <>
            <StyledButton
                href={useComparisonTable || addWashButton ? null : url}
                onClick={doButtonAction}
            >
                {icon ? (
                    <Icon
                        {...{ icon }}
                        color="black"
                        sizeLarge={30}
                        size={30}
                        sizeMobile={26}
                    />
                ) : null}
                <span>{formatText(title)}</span>
            </StyledButton>
            {useComparisonTable ? (
                <Modal open={open} setOpen={setOpen}>
                    <ComparisonTable
                        productCategory={comparisonTableProductCategory}
                    />
                </Modal>
            ) : addWashButton && isLoggedIn ? (
                <AddWashModal open={open} setOpen={setOpen} />
            ) : null}
        </>
    );
};

ButtonGroupButton.propTypes = {
    url: PropTypes.string,
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    useComparisonTable: PropTypes.bool,
    comparisonTableProductCategory: PropTypes.string,
    addWashButton: PropTypes.bool
};
export default ButtonGroupButton;
